import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import checked from '../assets/images/checkbox-selected.png';
import unchecked from '../assets/images/checkbox-unselected.png';
import { useTestState } from '../context/TestContext';
import useTracking from '../hooks/useTracking';

const Environment = ({ isB2b }: { isB2b?: boolean }) => {
  const { state, dispatch } = useTestState();
  const { trackEvent } = useTracking();
  const navigate = useNavigate();
  const { t } = useTranslation('environment');

  const [checkedArray, setCheckedArray] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [tracked, setTracked] = useState(false);

  useEffect(() => {
    if (!state.contactid && !isB2b) {
      return navigate('/demographics');
    }
  }, [isB2b, navigate, state.contactid]);

  useEffect(() => {
    dispatch({ type: 'UPDATE_PROGRESS', payload: 60 });
  }, [dispatch]);

  useEffect(() => {
    if (!tracked && state.email)
      trackEvent('JHT_ENVIRONMENT_PAGE_LOAD');
    setTracked(true);
  }, [state.email, trackEvent, tracked]);

  const handleButtonClick = (index: number) => {
    const updatedArray = [...checkedArray];
    updatedArray.splice(index, 1, true);
    setCheckedArray(updatedArray);
  };

  return (
    <div className="environment">
      <h1 className="top-title-text">{t('title')}</h1>
      <p>
        {t('subtitle')} <strong>{t('subtitle-bold')}</strong>
      </p>
      <div className="main-content">
        <button
          className="environment-button"
          onClick={() => handleButtonClick(0)}
        >
          <img src={checkedArray[0] ? checked : unchecked} alt="checkbox" />
          <p>{isB2b ? t('checkboxes-b2b.age') : t('checkboxes.age')}</p>
        </button>
        <button
          className="environment-button"
          onClick={() => handleButtonClick(1)}
        >
          <img src={checkedArray[1] ? checked : unchecked} alt="checkbox" />
          <p>{isB2b ? t('checkboxes-b2b.quiet') : t('checkboxes.quiet')}</p>
        </button>
        <button
          className="environment-button"
          onClick={() => handleButtonClick(2)}
        >
          <img src={checkedArray[2] ? checked : unchecked} alt="checkbox" />
          <p>{isB2b ? t('checkboxes-b2b.volume') : t('checkboxes.volume')}</p>
        </button>
        <button
          className="environment-button"
          onClick={() => handleButtonClick(3)}
        >
          <img src={checkedArray[3] ? checked : unchecked} alt="checkbox" />
          <p>
            {isB2b
              ? t('checkboxes-b2b.noise-canceling')
              : t('checkboxes.noise-canceling')}
          </p>
        </button>
        <button
          className="environment-button"
          onClick={() => handleButtonClick(4)}
        >
          <img src={checkedArray[4] ? checked : unchecked} alt="checkbox" />
          <p>
            {isB2b
              ? t('checkboxes-b2b.hearing-aids')
              : t('checkboxes.hearing-aids')}
          </p>
        </button>
      </div>
      <Link
        className={`
          link-button 
          ${checkedArray.includes(false) ? 'link-button-disabled' : ''}
        `}
        to="/headphones"
      >
        {t('continue')}
      </Link>
    </div>
  );
};

export default Environment;
